import { render, staticRenderFns } from "./ClientFinal.vue?vue&type=template&id=6e5d727d&scoped=true&"
import script from "./ClientFinal.vue?vue&type=script&lang=js&"
export * from "./ClientFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d727d",
  null
  
)

export default component.exports